/*
  JS del header. Antes eran cuatro <script> inline en sections/header.liquid;
  van en el mismo orden. Las URLs de assets y el texto de Air PRO vienen de
  window.sensiboHeaderAssets, que define el header.
*/

/* ===== Paginacion de articulos del buscador (corre apenas carga) ===== */
  let currentPage = 1;
  const slotsPerPage = 3;

  function updateVisibleSlots() {
    const startIndex = (currentPage - 1) * slotsPerPage + 1;
    const endIndex = startIndex + slotsPerPage - 1;

    document.querySelectorAll('.blog-result-slot').forEach(slot => {
      slot.style.display = 'none';
    });

    for (let i = startIndex; i <= endIndex; i++) {
      const slot = document.getElementById(`result-${i}`);
      if (slot) {
        slot.style.display = 'block';
      }
    }

    const totalPages = 3;
    const info = document.getElementById('page-info');
    if (info) info.textContent = `Page ${currentPage} of ${totalPages}`;
    if (prevPage) prevPage.disabled = currentPage === 1;
    if (nextPage) nextPage.disabled = currentPage === totalPages;
  }

  // Estos botones son la paginacion de articulos del buscador, que vive en el
  // header completo. En /cart ese header no se emite, asi que aca no hay nada
  // que enganchar.
  const prevPage = document.getElementById('prev-page');
  const nextPage = document.getElementById('next-page');

  if (prevPage) prevPage.addEventListener('click', () => {
    if (currentPage > 1) {
      currentPage--;
      updateVisibleSlots();
    }
  });

  if (nextPage) nextPage.addEventListener('click', () => {
    if (currentPage < 3) {
      currentPage++;
      updateVisibleSlots();
    }
  });

  updateVisibleSlots();

/* ===== Mega menu de Products: imagen y texto del producto que se sobrevuela ===== */
  document.addEventListener('DOMContentLoaded', function () {
    const productItems = document.querySelectorAll('.product-menu-item');
    const featuredImage = document.getElementById('mega-menu-featured-image');
    const productDescription = document.getElementById('product-description');
    const productTitle = document.getElementById('product-title-navbar-main-desktop');
    const starsImage = document.querySelector('.air-pro-icon');
    // Lo que muestra la tarjeta cuando no hay nada sobrevolado: viene del bloque
    // "Products: featured product" del editor del tema (data-* en el HTML).
    const featuredCard = document.querySelector('[data-featured-default]');
    if (!featuredImage || !productDescription || !productTitle || !starsImage || !featuredCard) return;

    const fourPointFiveStarProducts = (featuredCard.dataset.halfStarHandles || '')
      .split(',')
      .map((handle) => handle.trim())
      .filter(Boolean);

    // mouseenter para el mouse y focusin para el teclado: antes el producto
    // destacado solo cambiaba con el mouse.
    function showProduct() {
        // Era '#product-container', un id repetido diecisiete veces en la
        // pagina. Andaba de casualidad: al ser this.querySelector, la busqueda
        // arranca adentro del <li> que se esta sobrevolando, asi que nunca
        // llegaba a chocar con los otros dieciseis. Con getElementById habria
        // devuelto siempre el primero. Ahora es un data attribute, que es lo
        // que corresponde para un gancho de JS que se repite.
        const container = this.querySelector('[data-product-container]');
        if (!container) return;
        const productHandle = container.getAttribute("data-value");
        const metafield = container.getAttribute("data-metafield");
        const productTitleData = container.getAttribute("data-product-title");

        productDescription.textContent = metafield;
        productTitle.textContent = productTitleData;

        if (productHandle) {
          // Si una imagen anterior fallo y quedo oculta, se vuelve a mostrar.
          featuredImage.style.display = '';
          featuredImage.src = window.sensiboHeaderAssets.productImage.replace('HANDLE', productHandle);
          featuredImage.alt = productTitleData || 'Featured Product';
          featuredImage.onerror = function () { this.style.display = 'none'; };
          featuredImage.loading = 'lazy';
          if (fourPointFiveStarProducts.includes(productHandle)) {
            starsImage.src = window.sensiboHeaderAssets.stars45;
          } else {
            starsImage.src = window.sensiboHeaderAssets.stars5;
          }
        }
    }

    productItems.forEach(item => {
      item.addEventListener('mouseenter', showProduct);
      item.addEventListener('focusin', showProduct);
    });

    const megaMenu = featuredCard.closest('.mega-menu__content');
    if (megaMenu) {
      megaMenu.addEventListener('mouseleave', function () {
        featuredImage.src = featuredCard.dataset.image;
        featuredImage.alt = featuredCard.dataset.title;
        featuredImage.style.display = 'block';
        starsImage.src = featuredCard.dataset.stars;
        productTitle.textContent = featuredCard.dataset.title;
        productDescription.textContent = featuredCard.dataset.text;
      });
    }
    // Dos lineas mas arriba megaMenu ya se consulta con un if, porque puede no
    // estar. Aca faltaba la misma guarda: en /cart no hay mega menu.
    if (megaMenu) {
      megaMenu.querySelectorAll('img').forEach(img => {
        img.loading = 'lazy';
        img.fetchPriority = 'low';
      });
    }
  });

/* ===== Drawer mobile =====
   Aca habia un script que ponia overflow:hidden en el body y cerraba el drawer
   al tocar afuera. Leia aria-expanded en el mismo click en que MenuDrawer
   (global.js) lo cambiaba, asi que hacia todo al reves: lo reseteaba al abrir
   y dejaba el overflow puesto al cerrar. MenuDrawer ya maneja aria-expanded y
   el bloqueo del scroll (clase overflow-hidden-tablet en el body). */

/* ===== /pages/tv-presentation-for-ihtf: esconde los widgets de chat ===== */
  document.addEventListener('DOMContentLoaded', function () {
    if (window.location.pathname === '/pages/tv-presentation-for-ihtf') {
      setTimeout(() => {
        const messengerButton = document.getElementById('chat-button');
        const merchantWidget = document.getElementById('merchantwidget-iframe-wrapper');

        if (messengerButton) {
          messengerButton.style.display = 'none';
        }
        if (merchantWidget) {
          merchantWidget.style.display = 'none';
        }
      }, 6000);
    }
  });
